module.exports = __webpack_public_path__ + "media/images/common/arrow-d343609f6027aa2fd1f2bf22fb86be4a.png";